import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doAdd: { api: 'T0010UsersService.M20901_doAdd'},
    getEdit: { api: 'T0010UsersService.M20901_getEdit'},
    doEdit: { api: 'T0010UsersService.M20901_doEdit'},
    doRead: { api: 'T0010UsersService.M20901_doRead'},
    doDelete: { api: 'T0010UsersService.M20901_doDelete'},
    doBrowse: { api: 'T0010UsersService.M20901_doBrowse'},
    getTableColumnDefsDataForSearchTable: { api: 'T0010UsersService.M20901_getTableColumnDefsDataForSearchTable'},
    getTableColumnDefsDataForAtForm: { api: 'T0010UsersService.M20901_getTableColumnDefsDataForAtForm'},

    getStudentList: { api: 'T0010UsersService.M20901_getStudentDropdown', input: {}},
    getTeacherList: { api: 'T2010TeacherBasicService.getAllTeacher', input: {}},
    getClassroomList: { api: 'M0120ClassroomService.getClassroomsDropdown', input: {}},
    getCenterList: { api: 'M0110CenterService.getCentersDropdown_ShortLabel', input: { searchInfo: { group_flag: 0 } }},
    getPermissionList: { api: 'T0012AuthorityService.getAllAuthority', input: {}},
  },
}

const module = {
  state: {
    PageConst,

    studentList: [],
    teacherList: [],
    classroomList: [],
    centerList: [],
    permissionList: [],
  },

  getters: {},

  mutations: {},

  actions: {
    async getList ({ state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          { api: PageConst.ACTION[payload.api].api, input: payload.input ?? {} },
        ]
      }, false)
      state[payload.state] = res[0].output
    },
    async resetInitPassword ({ state }, payload) {
      return await ApiUtils.postData({
        data: [
          { api: 'T0010UsersService.M20901_resetInitPassword', input: { user_no: payload.user_no } },
        ]
      })
    },
    async exportCSV ({ state }) {
      const res = await ApiUtils.postData({
        data: [{
          api: 'T0010UsersService.M20901_exportCSV',
          input: { searchInfo: state.searchInfo }
        }]
      })
      return res[0].output;
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
